/* eslint-disable */
import React from 'react';
import CSSModules from 'react-css-modules';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import getPreparedProfileData from '../../utils/getPreparedProfileData';
import { INTRO_HINT_SELECTORS } from '../common/Intro';
import Avatar from '../Avatar';
import Card from '../Card';

import styles from './style.styl';

const ContextProfile = ({ profileLink, profileData, genderList, formatMessage }) => {
  const { avatar, name, shortDescription } = getPreparedProfileData(
    profileData,
    genderList,
    formatMessage,
  );

  return shortDescription ? (
    <Link to={profileLink} className="g-hoverable">
      <div styleName="card-wrapper">
        <Card
          userId={get(profileData, 'id')}
          className="fw6"
          text={{
            primary: name,
            complementary: shortDescription,
            intro: INTRO_HINT_SELECTORS.patient.messages.patientContext,
          }}
          additionalContent={{
            left: <Avatar children={name} size={48} src={avatar} />,
          }}
          styleName="card"
        />
      </div>
    </Link>
  ) : null;
};

ContextProfile.propTypes = {
  profileLink: PropTypes.string,
  profileData: PropTypes.object,
  genderList: PropTypes.array,
};

export default CSSModules(ContextProfile, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/ContextProfile.jsx